import { PayFor, PaymentMethod, Client } from '../../../pure-js/types/GrooverTypes'
import { resolveAdministrationFeeAmount } from '../../../pure-js/libs/PaymentHelper'

export type FormatToBePaidParams = {
  payFor: PayFor
  p: PayFor
  isTotal?: boolean
  userCredit?: number
  paymentMethod?: PaymentMethod
  client?: Client
  basePrice: number
  toBePaid: Record<PayFor, number>
  enrollmentPriceDetails?: Array<{ appliesTo: string; administrationFee?: number; finalPrice: number }>
  // Note: payFor, p, toBePaid, enrollmentPriceDetails are kept for potential future use
}

/**
 * Formats the amount to be paid for a given PayFor option
 *
 * For individual prices (Main/Partner rows): shows price WITHOUT payment method fee
 * For total row: shows price WITH payment method fee
 */
export const formatToBePaid = (params: FormatToBePaidParams): string => {
  const { userCredit, basePrice, toBePaid, p, isTotal, paymentMethod, client } = params

  const getValueOrUserCredit = (value: number, userCredit?: number) => {
    if (userCredit !== undefined) {
      return Math.min(value, userCredit)
    }
    return value
  }

  const formatAmount = (amount: number) => (amount / 100).toFixed(2).toString().replace('.00', '')

  // Use toBePaid if available (accounts for payments made), otherwise fall back to basePrice
  // toBePaid contains base prices without administration fee
  const remainingAmount = toBePaid && toBePaid[p] !== undefined ? toBePaid[p] : basePrice

  // For total row, add the payment method fee (from currently selected payment method)
  const fee =
    isTotal && paymentMethod && client ? resolveAdministrationFeeAmount(paymentMethod, client, remainingAmount) : 0
  const totalAmount = remainingAmount + fee

  const amount = getValueOrUserCredit(totalAmount, userCredit)
  return formatAmount(amount)
}
